const buttonClasses = 'border-2 border-primary-600 text-primary-600';

const buttonHoverClasses =
  'hover:bg-primary-900 hover:text-white hover:border-primary-900 [&:hover_svg]:fill-white';

const buttonIconClasses = 'fill-primary-600';

const buttonPrimaryOutlinedClasses = {
  buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses],
  buttonIconClasses,
};

export default buttonPrimaryOutlinedClasses;
